<template>
  <el-table ref="multipleTable" v-loading="loading" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
    <el-table-column type="selection" width="55">
    </el-table-column>
    <el-table-column prop="issueid" label="编号" width="120" sortable>
    </el-table-column>
    <el-table-column prop="title" label="标题" width="200" >
    </el-table-column>
    <el-table-column prop="label" label="类型" width="200">
    </el-table-column>
    <el-table-column prop="solution" label="解决方案" width="300">
    </el-table-column>
    <el-table-column prop="time" label="日期" width="150">
    </el-table-column>
    <el-table-column prop="detail" label="操作" width="200">
      <template #default="scope">
        <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row.issueid)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div style="margin-top: 20px">
    <el-button @click="toggleSelection()">取消选择</el-button>
  </div>
</template>

<script>
import {kball,kbDel} from "../../axios";
import axios from 'axios';
import { ElMessage } from "element-plus";
import { baseUrl_New } from "../../axios/urlconfig";
import { deleteRequest } from '../../axios/axios';

export default {
  name: "kbshow",
  props:['issueid','title','label','solution','time'],
  data() {
    return{

      allkb:[],
      tableData :[{
        issueid:'1',
        label:'jack',
        solution:'ssh',
        time:'123456'
      }],
      multipleSelection: [],
      loading: true,
    }
  },


  created() {
    this.kball();
    this.updatetable();
  },

  methods:{
    kball(){
      kball().then(res=>{
        this.allkb = res.data;
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },

    updatetable(){
      this.loading = true;
      kball({
        issueid: this.issueid
      }).then(res=>{
        // console.log(res);
        this.tableData = res.data;
        this.loading = false;
      }).catch(err=>{
        console.log(err);
      });
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete(index, issueid){
          deleteRequest(baseUrl_New + `/kbDel/${issueid}`)
              .then(response=>{
                // console.log(response);
                  if (response.code == 0){
                    ElMessage.success("删除成功");
                      this.updatetable();
                  }else{
                    ElMessage.error("删除失败");
                  }
              })
            },
  }
}
</script>

<style scoped>

</style>